import React from 'react';
import { connect } from 'react-redux';
import Skeleton from 'ui/Skeleton';
import AssignmentDate from './AssignmentDate';
import CertificationOverviewHeader from './CertificationOverviewHeader';

const Header = props => {
  const {
    title,
    description,
    assignment,
    loading,
    certification,
    showCertificateModalInPreview,
  } = props;
  if (certification) {
    return (
      <CertificationOverviewHeader
        showCertificateModalInPreview={showCertificateModalInPreview}
        {...props}
      />
    );
  }
  return (
    <div className="PathViewerHeader">
      <div className="PathViewerHeader-info jc-sb d-f">
        <h1 className="PathViewerHeader-title">
          {loading ? <Skeleton width="55%" /> : title}
        </h1>
        <AssignmentDate {...assignment} />
      </div>
      {description && (
        <p className="PathViewerHeader-description">{description}</p>
      )}
    </div>
  );
};

const mapStateToProps = ({ pathViewer }) => ({
  pathProgressId: pathViewer.pathProgressId,
  title: pathViewer.title,
  description: pathViewer.description,
  assignment: pathViewer.assignment,
  loading: pathViewer.loading,
  certification: pathViewer.badge,
  image: pathViewer.image,
  contents: pathViewer.contents,
  hasHiddenContents: pathViewer.hiddenContents,
  estimatedMinutesToComplete: pathViewer.estimatedMinutesToComplete,
  progress: pathViewer.progress,
  isComplete:
    pathViewer.contents &&
    pathViewer.contents.every(content => content.status === 'completed'),
});

export default connect(mapStateToProps)(Header);
